<template>
    <div class="rsv2_info_pop_left">
        <div class="rsv2_info_pop_title" v-if="isShowUserInfoTitle == true">{{ $t('popup_user_reservation.title') }}</div>
        <UserInfo ref="UserInfo" :hservice="hservice" :reservationUserNote="reservationUserNote" :note="note" />
        <!-- 치료 히스토리 -->
        <ReservationHistory 
            :hservice="hservice" 
            :reservations="reservations" 
            :note="note"
            :reservationUserNote="reservationUserNote"
            :selectedReservationID="selectedReservationID" 
            :isHistoryLoading="isHistoryLoading"
            @setSelectedReservationID="setSelectedReservationID"
            @showReservationChangeHistory="showReservationChangeHistory"
            @hideReservationChangeHistory="hideReservationChangeHistory" />
        <!-- 예약 변경내역 -->
        <ReservationChangeHistory 
            :selectedReservationID="selectedReservationID"
            :isShowChangeHistoryPopup="isShowChangeHistoryPopup"
            @hideReservationChangeHistory="hideReservationChangeHistory" />
    </div>
</template>

<script>
import UserInfo from './Components/UserInfo.vue'
import ReservationHistory from './Components/ReservationHistory.vue'
import ReservationChangeHistory from './Components/ReservationChangeHistory.vue'
import { sheetRefresh } from '../../../../sheet-refresh'
import { useQueryClient } from '@tanstack/vue-query'
import { v2ReservationListQueryOptions } from '@/composables/queries/v2reservation/use-v2-reservation-list-query'
import { v2ReservationUserNoteFindQueryOptions } from '@/composables/queries/v2reservationusernote/use-v2-reservationusernote-find-query'

export default {
    setup() {
        const queryClient = useQueryClient()
        return { queryClient }
    },
    components: { UserInfo, ReservationHistory, ReservationChangeHistory },
    props: {
        isShowPopup: Boolean,
        hservice: Object,
        isShowUserInfoTitle: Boolean
    },
    data() {
        return {
            sheetRefresh,
            reservations: [],
            note: undefined,
            reservationUserNote: undefined,
            selectedReservationID: undefined,
            isShowChangeHistoryPopup: false,
            isHistoryLoading: false
        }
    },
    watch: {
        'sheetRefresh.refreshFlagMoment': {
            handler: function () {
                this.requestFetchUserNote()
            }
        },
        hservice: {
            immediate: true,
            deep: true,
            handler: function (newValue, oldValue) {
                if (newValue?._id == oldValue?._id) return

                this.initializeData()
                this.requestFetchReservationList()
                this.requestFetchUserNote()
            }
        }
    },
    methods: {
        initializeData() {
            this.reservations = []
            this.note = undefined
            this.selectedReservationID = undefined
        },

        setSelectedReservationID(id) {
            this.selectedReservationID = id
        },

        showReservationChangeHistory() {
            this.isShowChangeHistoryPopup = true
        },

        hideReservationChangeHistory() {
            this.isShowChangeHistoryPopup = false
        },

        // MARK: - Network
        async requestFetchReservationList() {
            try {
                this.reservations = []
                if (!this.hservice?._id) return

                this.isHistoryLoading = true
                let param = {
                    hserviceID: this.hservice._id,
                    isRemoved: false,
                    key: 'startedAt',
                    way: -1
                }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                this.reservations = await this.queryClient.fetchQuery(v2ReservationListQueryOptions(param))
            } catch (err) {
                console.log('reservation history find error : ', err)
            } finally {
                this.isHistoryLoading = false
            }
        },

        async requestFetchUserNote() {
            try {
                const hospitalID = this.hospital.selectedHospital._id
                const hserviceID = this.hservice?._id
                const userID = this.hservice?.userID?._id
                if (hserviceID == undefined || userID == undefined) {
                    throw new Error('hserviceID or userID is undefined')
                }
                const model = { hospitalID, hserviceID, userID }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                const notes = await this.queryClient.fetchQuery(v2ReservationUserNoteFindQueryOptions(model))
                this.reservationUserNote = notes[0]
                this.note = this.reservationUserNote?.content || ''
            } catch (err) {
                console.log('user note find error : ', err)
            } 
        }
    }
}
</script>
